import { render, staticRenderFns } from "./petrolapprove.vue?vue&type=template&id=40d1c458&"
import script from "./petrolapprove.vue?vue&type=script&lang=js&"
export * from "./petrolapprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports